import PropTypes from 'prop-types';
import React from 'react';

function displayFooter() {
    $('#page-container').addClass("display-shop");
}

class BleepShop extends React.Component {
    componentDidMount() {
        const that = this;

        function buildShop(sessionBroadcasts) {
            if (typeof buy !== 'undefined') {
                buy.cart("#cart-holder", {
                    coreHost: that.props.shopHostUrl,
                }, (cartObject) => {
                    if (cartObject.itemCount > 0) {
                        displayFooter();
                    }
                });
                sessionBroadcasts.slice(0, 4).forEach((sessionBroadcast, i) => {
                    buy.products(`.session-item--${i+1} .session-item__right`, {
                        style: "mini",
                    }).get(sessionBroadcast.shopIds);
                });

                setTimeout(() => {
                    let displayShopFooter = false;
                    $(document).on('click', '.ochre-buy-button', () => {
                        if (typeof ga !== "undefined") ga('send', 'event', 'Autechre', 'Shop', 'AddToCart');

                        if (!displayShopFooter) {
                            displayFooter();
                            displayShopFooter = true;
                        }
                    });

                    $(document).on('click', '.ochre-checkout-button', () => {
                        if (typeof ga !== "undefined") ga('send', 'event', 'Autechre', 'Shop', 'Checkout');
                    });
                }, 1000);
            } else {
                setTimeout(buildShop, 500, sessionBroadcasts);
            }
        }

        setTimeout(buildShop, 500, this.props.sessionBroadcasts);
    }

    shouldComponentUpdate() {
        return false;
    }

    render() {
        return (
            <div id="cart-holder" />
        );
    }
}

BleepShop.propTypes = {
    sessionBroadcasts: PropTypes.array.isRequired,
    shopHostUrl: PropTypes.string.isRequired,
};

export default BleepShop;



// WEBPACK FOOTER //
// ./src/components/BleepShop.jsx